var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgActiveControl = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 20,
    rx: 10,
    fill: "#B3E7FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#00B0F5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActiveControl, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ActiveControl.807dd3dd.svg";
export { ForwardRef as ReactComponent };